// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__yry-h","paramInput":"JobSimulator_paramInput__6kCiD","input":"JobSimulator_input__2a2f3"};